/** Close chrome height on mobile overlay sheets (80px). */
export const OVERLAY_CLOSE_BAR_BLOCK_SIZE = '5rem';

/**
 * Desktop overlay threat-grid max height (504px).
 * Caps card stretch when the modal sheet is taller than the grid content.
 */
export const OVERLAY_THREAT_GRID_MAX_BLOCK_SIZE = '31.5rem';

/** Enabler overlay hero plates — Figma Circles Solution modules @ 2× JPG (715×640). */
export const OVERLAY_ENABLER_MEDIA_DIR = '/media/overlay-enablers';
export const OVERLAY_ENABLER_MEDIA_WIDTH = 1430;
export const OVERLAY_ENABLER_MEDIA_HEIGHT = 1280;
/** Mobile stacked image ratio (brief); desktop fills the panel half. */
export const OVERLAY_ENABLER_MEDIA_MOBILE_ASPECT_RATIO = '715 / 460';
export const OVERLAY_ENABLER_MEDIA_SIZES = '(min-width: 64rem) 50vw, 100vw';

/** Filename stem (no extension) per enabler overlay entry id. */
export const OVERLAY_ENABLER_MEDIA_STEM = {
  'coordinate-action-along-flyways': 'coordinate-action',
  'influence-policy-and-legislation': 'influence-policy',
  'mobilise-finance-for-flyways': 'mobilise-finance',
  'empower-indigenous-peoples-and-local-communities': 'empower-communities',
  'strengthen-capacity-and-raise-awareness': 'strengthen-capacity',
  'monitor-bird-populations': 'monitor-bird-populations',
} as const;

export type OverlayEnablerMediaId = keyof typeof OVERLAY_ENABLER_MEDIA_STEM;

export function overlayEnablerMediaSrc(id: OverlayEnablerMediaId): string {
  return `${OVERLAY_ENABLER_MEDIA_DIR}/${OVERLAY_ENABLER_MEDIA_STEM[id]}.jpg`;
}
